

import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {getText, renderMarkdown} from 'helpers/text-helper';
import {getGameResults} from 'helpers/game-helper';
import GameProgress from 'components/ui/game-progress/game-progress';
import Button from 'components/ui/button/button';
import Result from 'components/ui/result/result';
import './game-results-outro.scss';

const GameResultsOutro = ({languageId, deviceInfo, gameData, groupsData, goToPage}) => {

	const [showResultsPopup, setShowResultsPopup] = useState(false);

	/* Get results of last survey */
	const resultsData = getGameResults(gameData, groupsData);
	const currentResultData = resultsData.length > 0 ? resultsData[resultsData.length - 1] : null;

	return (
		<div className={'GameResultsOutro ' + deviceInfo.orientation}>
			{/* Home btn */}
			<div className="GameResultsOutro-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			<div className="GameResultsOutro-content">
				{/* Game progress */}
				<GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>

				{/* Title & text */}
				<div className='GameResultsOutro-title'>
					<span>{getText('pages_gameResultsOutro_title', languageId)}</span>
				</div>
				<div className='GameResultsOutro-text'>
					{renderMarkdown(getText('pages_gameResultsOutro_text', languageId))}
				</div>

				<div className="GameResultOutro-resultsBtn">
					<Button 
						classes={['orange', 'fullHeight']}
						text={getText('pages_gameResultsOutro_btn', languageId)}
						onClick={() => {setShowResultsPopup(true);}}
					/>	
				</div>
			</div>

			<div className="GameResultsOutro-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-results');}}
				/>
			</div>
			<div className="GameResultsOutro-nextBtn">
				<Button 
					classes={['orange', 'next', 'fullHeight']}
					text={getText('general_next', languageId)}
					onClick={() => {goToPage('game-experiment');}}
				/>
			</div>


			{showResultsPopup && <div className="GameResultsOutro-popup">
				<div className="GameResultsOutro-popupContent">
					<div className="GameResultsOutro-popupCloseBtn" onClick={() => {setShowResultsPopup(false);}}/>
					<div className="GameResultsOutro-popupResult">
						<Result 
							layout="popup"
							resultId={currentResultData.id}
							languageId={languageId}
							deviceInfo={deviceInfo} 
							resultData={currentResultData}
						/>
					</div>
				</div>
			</div>}
		</div>
	);
};

GameResultsOutro.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	groupsData: PropTypes.array.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameResultsOutro;